import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import useValidators from 'components/Form/validations/useValidators';
import { format } from 'date-fns';

const useValidationSchema = (validFromInitial: Date | null, validToInitial: Date | null) => {
  const { t } = useTranslation('Errors');
  const { required, dateComparison, integer, number, testLengthUnder60Hours, min } =
    useValidators();
  const TestFormSchema = yup.object().shape({
    name: required(yup.string()),
    type: required(yup.string()),
    validFrom: required(
      validFromInitial
        ? yup.date().test('Check if the new date has changed', t('dateInPast'), function (value) {
            const oldDate = format(new Date(validFromInitial), 'yyyyMMdd');
            const newDate = format(new Date(value!), 'yyyyMMdd');
            const today = format(new Date(), 'yyyyMMdd');
            return newDate === oldDate ? true : newDate >= today;
          })
        : yup.date().min(new Date(+new Date() - 86400000), t('dateInPast')),
    ).typeError(t('invalidDate')),

    validTo: validToInitial
      ? required(
          yup
            .date()
            .test('Check if the new date has changed', t('dateInPast'), function (value, context) {
              const oldDate = format(new Date(validToInitial), 'yyyyMMdd');
              const newDate = format(new Date(value!), 'yyyyMMdd');
              const today = format(new Date(), 'yyyyMMdd');
              const validFrom = format(new Date(context.parent.validFrom), 'yyyyMMdd');
              return newDate < validFrom ? false : newDate >= today ? true : newDate === oldDate;
            }),
        ).typeError(t('invalidDate'))
      : dateComparison(required(yup.date().typeError(t('invalidDate'))), 'validFrom'),

    maxWrongAnswersAllowed: required(min(integer(number(yup.number())), 0, 'minLengthNumber')),
    maxTestLength: required(testLengthUnder60Hours(yup.string())),
  });

  return {
    TestFormSchema,
  };
};

export default useValidationSchema;
